export default __webpack_public_path__ + "static/media/german.75b147b5.webp";